import * as React from "react";
import { Link } from "gatsby";
import Col from "../../../components/global/Col/Col";
import { Container } from "react-bootstrap";
import {
  styledContainer,
  title,
  title2,
  description,
  descContainer,
  titleContainer,
} from "./PageIntro.module.scss";
import { Title3Props } from "./PageIntroProps";

export const StyledContainer = (props: { children: any }): JSX.Element => {
  return <Container className={styledContainer}>{props.children}</Container>;
};
export const TitleContainer = (props: { children: any }): JSX.Element => {
  return <Col className={`col4 ${titleContainer}`}>{props.children}</Col>;
};

export const DescContainer = (props: { children: any }): JSX.Element => {
  return <Col className={`col7 ${descContainer}`}>{props.children}</Col>;
};

export const Title: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={title}>
      <h1>{props.children}</h1>
    </div>
  );
};

export const Title2: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={title2}>
      {props.children}
    </div>
  );
};

export const Title3: React.FC<Title3Props> = (props) => {
  return (
    <div id={props.id} className={title}>
      <h2>{props.children}</h2>
    </div>
  );
};

export const Description: React.FC<any> = ({
  field_link,
  field_description,
  children,
}) => {
  const link = field_link;
  return (
    <div className={description}>
      <p
        id={`page-intro-description`}
        dangerouslySetInnerHTML={{ __html: field_description }}
        className="font-weight-light description"
      />
      {link && (
        <div>
          {link.url.indexOf("https://") > -1 && (
            <>
              <a
                id="page-intro-link"
                target="_blank"
                href={link.url}
                className="btn btn-primary text-uppercase mainLink px-5"
                rel="noreferrer"
              >
                {link.title}
              </a>
            </>
          )}
          {link.url.indexOf("https://") === -1 && (
            <>
              <Link
                id="page-intro-link"
                to={link.url}
                className="btn btn-primary text-uppercase mainLink px-5"
              >
                {link.title}
              </Link>
            </>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
